/*
 * Maison Avéla — scroll bridge.
 *
 * This store does not scroll in the window. `html` and `body` are locked
 * with overflow:hidden at viewport height, and the real scrolling happens
 * inside `.page-wrapper`.
 *
 * Scroll events do not bubble: an event fired at an element reaches that
 * element only, never `window`. Anything that listens on `window` for
 * scroll therefore never hears about it — including Horizon's own sticky
 * add-to-cart, which is why the bar appeared at random and then refused to
 * hide again when the real button came back into view.
 *
 * This forwards each scroll of the container to `window`, once per frame,
 * so listeners written the normal way keep working. It reads nothing and
 * changes nothing else; remove the file and the store behaves exactly as
 * it did before.
 */
(function () {
  'use strict';

  var pending = false;

  function forward() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      window.dispatchEvent(new Event('scroll'));
    });
  }

  function attach() {
    var containers = document.querySelectorAll('.page-wrapper');

    for (var i = 0; i < containers.length; i++) {
      var el = containers[i];
      if (el.getAttribute('data-ma-scroll-bridge') === '1') continue;

      var overflow = window.getComputedStyle(el).overflowY;
      if (overflow !== 'auto' && overflow !== 'scroll') continue;

      el.setAttribute('data-ma-scroll-bridge', '1');
      el.addEventListener('scroll', forward, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }

  // The container only becomes scrollable at some widths, so re-check.
  window.addEventListener('resize', attach);
  document.addEventListener('shopify:section:load', attach);
})();